import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import axios from 'axios';
import { toast } from 'react-toastify';
import TaskJobDetails from './TaskJobDetails';
import Invoices from './Invoices';
import authService from './api-authorization/AuthorizeService';

interface ChargeCreditCard {
    id: number;
    jobDetails: JobDetails;
    invoiceDetails: InvoiceDetails[];
    invoiceTotalFormatted: string;
    cardChargedId: number;
    loading: boolean;
    errors: any;
}

interface JobDetails {
    jobId: number;
    customer: string;
    customerContact: string;
    mobile: string;
    phone: string;
    email: string;
    siteAddress: string;
    lotNumber: string;
}

interface InvoiceDetails {
    id: number;
    companyId: number;          //job company id
    invoiceCompanyId: number;   //invoice company id => used to send to the correct Reckon
    customer: string;
    customerType: string;
    jobId: number;
    siteAddress: string;
    type: string;
    sendTo: string;
    batchNumber: string;
    reckonInvoiceId: string;
    canUpdateReckonInvoiceId: boolean;
    quoteNumber: string;
    hirePeriod: string;
    invoiceDate: string;
    dueDate: string;
    paidDate: string;
    paidDateActual: string;
    amount: string;
    errorMessage: string;
    status: string;
    statusId: number;
    canEdit: boolean;
    canDelete: boolean;
    invoiceStartDate: string;
    invoiceStartDateFormatted: string;
    isDirty: boolean;
    items: InvoiceItems[];
    showDetail: boolean;
    errors: any;
}

interface InvoiceItems {
    itemIndex: number;
    id: number;
    jobInvoiceId: number;
    branchIdent: string;
    item: string;
    itemId: number;
    itemTypeId: number;
    invItemType: string;
    invItemTypeId: number;
    quantityType: string;
    purchaseOrderNumber: string;
    additionalHireRate: string;
    rate: string;
    rateFormatted: string;
    gst: string;
    gstFormatted: string;
    chargeGst: boolean;
    amount: string;
    amountFormatted: string;
    description: string;
    status: number;
    invoiceStartDate: string;
    invoiceEndDate: string;
    invoiceStartDateFormatted: string;
    invoiceEndDateFormatted: string;
    hirePeriodDays: string;
    hirePeriod: string;
    dayRate: string;
    weekMonthRate: string;
    isDirty: boolean;
}

interface INameToValueMap {
    [key: string]: any;
}

export class TaskChargeCreditCardData extends React.Component<RouteComponentProps<{}>, ChargeCreditCard> {
    constructor(props: any) {
        super(props);
        this.state = {
            id: 0,
            jobDetails: {
                jobId: 0,
                customer: "",
                customerContact: "",
                mobile: "",
                phone: "",
                email: "",
                siteAddress: "",
                lotNumber: ""
            },
            cardChargedId: -1,
            invoiceDetails: [],
            invoiceTotalFormatted: "$0.00",
            loading: true,
            errors: {}
        };
        
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        let jobParams: INameToValueMap = {};
        jobParams["id"] = 0;
        jobParams = this.props.match.params;
        let Id = jobParams["id"];
        this.setState({ id: Id });

        axios.get('api/User/CheckUserPermission?Permission=RunChargeCreditCardOverhireTask&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data == true) {
                //assign task to current user
                var taskdetails = {
                    Id: Id,
                    SubId: user.sub
                };
                axios.post('api/Tasks/AssignTask', taskdetails, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    //this needs to just happen in the background
                });

                axios.get('api/Tasks/GetTaskChargeCreditCardOverhire?Id=' + Id, {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                .then(res => {
                    var invoiceDetails = res.data.invoiceDetails;
                    for (var i = 0; i < invoiceDetails.length; i++) {
                        var invoice = invoiceDetails[i];
                        invoice.errors = {};

                        for (var y = 0; y < invoice.items.length; y++) {
                            invoice.items[y].itemIndex = y;
                            invoice.items[y].amount = invoice.items[y].amount.toFixed(2);
                        }
                    }
                    this.setState({ id: Id, jobDetails: res.data.jobDetails, invoiceDetails: invoiceDetails, loading: false });
                })
                .catch(error => {
                    toast.error(error.message);
                });
            } else {
                //redirect to 403 permission denied
                this.props.history.push("/accessdenied")
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let change: any = {};
        change[e.target.name] = e.target.value;
        change["errors"] = errors;
        this.setState(change);
    }

    updateInvoiceDetails = (updatedInvoices: InvoiceDetails[]) => {
        //need to update the invoice details when use clicks on the x to show details
        this.setState({ invoiceDetails: updatedInvoices });
    }

    pageChanged = (page: number) => {
        //not required as only showing 1 invoice
    }

    saveHirePeriod = (data: any) => {
        //not required as not able to update hire period here
    }

    validate = () => {
        let formIsValid = true;
        let errors: any = {};

        if (this.state.cardChargedId < 1) {
            formIsValid = false;
            errors["cardChargedId"] = "Was credit card successfully charged is required";
        } 

        this.setState({ errors: errors });
        return formIsValid;
    }

    contactSubmit = (e: any) => {
        e.preventDefault();
        if (this.validate()) {
            this.submit();
        } else {
            //alert("Form has errors.")
        }
    }

    submit = () => {
        this.save();
    }

    async save() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var details = {
            taskId: this.state.id,
            jobId: this.state.jobDetails.jobId,
            chargedCard: this.state.cardChargedId == 1 ? true : false,
            subId: user.sub
        };

        axios.post('api/Tasks/SaveChargeCreditCardOverhire', details, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            toast.success("Task Saved");
            this.props.history.push("/tasks")
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    public render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            <h1>Charge Credit Card for Overhire</h1>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var jobDetails = this.state.jobDetails;
        let taskJobDetails = <TaskJobDetails jobDetails={jobDetails} />
        var invoices = <Invoices invoiceDetails={this.state.invoiceDetails} invoiceTotalFormatted={this.state.invoiceTotalFormatted} showCustType={false} showJobInfo={false} showQuoteNo={false} showHirePeriod={true} showStatus={true} showStartDate={false} showPaidDate={false} showPaid={false} showSend={false} showReckonInvNo={false} showRemove={false} showSentTo={true} showError={false} showSent={false} canEdit={false} canEditHirePeriod={false} canSend={false} canUpdatePaid={false} page={1} pageSize={100} totalRecords={1} pageChanged={this.pageChanged} beforeValid={this.updateInvoiceDetails} afterValid={this.updateInvoiceDetails} saveHirePeriod={this.saveHirePeriod} />

        return (
            <form name="jobDetails" onSubmit={this.contactSubmit}>
                <div>
                    <span>Check Accounting Software to see if {jobDetails.customer} has paid for the below overhire:</span>
                    {taskJobDetails}
                    <br></br>
                    {invoices}
                    <span>If credit card has not been charged for above invoice, please charge the credit credit</span>
                    <div>
                        <label htmlFor="cardChargedId">
                            <span className="label tasks__labelsize">Was the credit card charged successfully?</span>
                            <select className="select" id="cardChargedId" name="cardChargedId" value={this.state.cardChargedId} onChange={(e) => this.handleChange(e)}>
                                <option hidden defaultValue="-1"></option>
                                <option value="1">Yes - Paid</option>
                                <option value="2">No - Not Paid</option>
                            </select>
                        </label>
                        <span className="label errors">{this.state.errors["cardChargedId"]}</span>
                    </div>
                    <br></br>
                    <div className="row">
                        <button className="defaultbutton-prev" type="submit">Save</button>
                    </div>
                </div>
            </form>
        );
    }
}